import { emojiPluginKey } from '../emojiPlugin';
export var ACTIONS = {
  SET_PROVIDER: 'SET_PROVIDER',
  SET_RESULTS: 'SET_RESULTS',
  SET_ASCII_MAP: 'SET_ASCII_MAP',
  SET_INLINE_POPUP: 'SET_INLINE_POPUP'
};
export var setAsciiMap = function setAsciiMap(asciiMap) {
  return function (tr) {
    return tr.setMeta(emojiPluginKey, {
      action: ACTIONS.SET_ASCII_MAP,
      params: {
        asciiMap: asciiMap
      }
    });
  };
};
export var openTypeAhead = function openTypeAhead(typeaheadHandler, api) {
  return function (inputMethod) {
    var _api$typeAhead;
    return Boolean(api === null || api === void 0 || (_api$typeAhead = api.typeAhead) === null || _api$typeAhead === void 0 ? void 0 : _api$typeAhead.actions.open({
      triggerHandler: typeaheadHandler,
      inputMethod: inputMethod
    }));
  };
};
export var setProvider = function setProvider(provider) {
  return function (tr) {
    return tr.setMeta(emojiPluginKey, {
      action: ACTIONS.SET_PROVIDER,
      params: {
        provider: provider
      }
    });
  };
};
export var setInlineEmojiPopupOpen = function setInlineEmojiPopupOpen(open) {
  return function (tr) {
    return tr.setMeta(emojiPluginKey, {
      action: ACTIONS.SET_INLINE_POPUP,
      params: {
        open: open
      }
    });
  };
};